import * as React from 'react';
import { FieldProps } from 'react-jsonschema-form-bs4';
import { MaskedTextBox, MaskedTextBoxChangeEvent } from '@progress/kendo-react-inputs';

export default class Phone extends React.Component<FieldProps, any> {

    constructor(props: FieldProps) {
        super(props);
        this.state = { ...props.formData };
    }

    onChange(name: string) {
        return (event: MaskedTextBoxChangeEvent) => {
            this.setState({ [name]: event.target.value });
            setImmediate(() => this.props.onChange(this.state[name]));
        };
    }

    public render() {
        return <React.Fragment>
            <div className="input-group">
                <div className="input-group-prepend">
                    <span className="input-group-text">{this.props.schema.title || "Phone"}{this.props.required && <span style={{ color: '#dc3545' }}>*</span>}</span>
                </div>
                <MaskedTextBox
                    disabled={this.props.disabled}
                    readonly={this.props.readonly}
                    mask="(000)000-0000"
                    placeholder="(000)000-0000"
                    value={this.state[this.props.name]}
                    defaultValue={this.props.formData}
                    onChange={this.onChange(this.props.name)}
                />
            </div>
        </React.Fragment>;
    }
}
